import { client } from "../client";
import type { Center } from "../types/center.types";
import type { User } from "../types/user.types";

export const createCenter = async ({ center }: { center: Partial<Center> }) => {
	const response = await client.post<Center>(`/centers/`, center);
	return response.data;
};

export const updateCenter = async ({ center }: { center: Partial<Center> }) => {
	const response = await client.patch<Center>(`/centers/${center.id}`, center);
	return response.data;
};

export const archiveCenterToggle = async ({
	id,
	isArchived,
}: {
	id: number | string | undefined;
	isArchived: boolean;
}) => {
	const response = await client.patch<void>(`/centers/${id}/`, {
		isArchived,
	});
	return response.data;
};

export const markAsVisited = async ({
	center,
}: {
	center: Partial<Center>;
}) => {
	const response = await client.post<Center>(`/centers/${center.id}/visited`);
	return response.data;
};

export const sendInvitations = async ({
	center,
	users,
}: {
	center: Partial<Center>;
	users: Partial<User>[];
}) => {
	const response = await client.post<Center>(
		`/centers/${center.id}/invitations`,
		{
			users,
		},
	);
	return response.data;
};

export const linkUsersToCenter = async ({
	center,
	users,
}: {
	center: Partial<Center>;
	users: Pick<User, "email" | "access" | "role">[];
}) => {
	const response = await client.post<void>(`/centers/${center.id}/link`, {
		users,
	});
	return response.data;
};

export const centerToggleSleepMode = async ({
	id,
	reason,
}: {
	id: number | string | undefined;
	reason?: string;
}) => {
	if (!id) {
		return null;
	}
	const response = await client.post<void>(`/centers/${id}/sleep`, { reason });
	return response.data;
};
